<template>
  
  <div class="common-layout" style="height:100%;">
    <el-container style="height:100%;">
      <el-header>Header</el-header>
      <el-container style="height:100%;">
        <el-aside style="height:100%;">
          <el-menu active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo"
            default-active="2" text-color="#fff" router>
            <el-sub-menu index="1">
              <template #title>
                <el-icon>
                  <location />
                </el-icon>
                <span>店铺信息</span>
              </template>
              <el-menu-item index="/shop/shoplist/1">店铺列表</el-menu-item>
              <el-menu-item index="/shop/ShopDetails/">店铺介绍</el-menu-item>
                  <el-menu-item index="FileConfig">配送设置</el-menu-item>
                      <el-menu-item index="FileConfig">运费模版</el-menu-item>
                          <el-menu-item index="/shop/classificationsettings/">店铺分类设置</el-menu-item>
                               <el-menu-item index="FileConfig">店长推荐</el-menu-item>
                               <el-menu-item index="FileConfig">新品推荐</el-menu-item>
            </el-sub-menu>

              <el-sub-menu index="2">
              <template #title>
                <el-icon>
                  <location />
                </el-icon>
                <span>商品管理</span>
              </template>
              <el-menu-item index="/products/ProductsList/1">我的商品</el-menu-item>
              <el-menu-item index="/products/ProductsCategory">添加商品</el-menu-item>
            </el-sub-menu>
               <el-sub-menu index="3">
              <template #title>
                <el-icon>
                  <location />
                </el-icon>
                <span>订单管理</span>
              </template>
              <el-menu-item index="/Orders/OrderList/1">订单列表</el-menu-item>
             
            </el-sub-menu>
          </el-menu>
        </el-aside>
        <el-main>
                <!-- <el-breadcrumb :separator-icon="ArrowRight">
            <el-breadcrumb-item :to="{ path: '/' }">主页</el-breadcrumb-item>
          
          </el-breadcrumb> -->
          <router-view />
        </el-main>
 
      </el-container>
    </el-container>
    <Layfooter></Layfooter>
  </div>
  </template>

  <script lang="ts">
import { Options, Vue } from 'vue-class-component';
 import { Location, Document, Setting, Menu, ArrowRight } from "@element-plus/icons-vue"
import Layfooter from '@/components/lay-footer/index.vue';
@Options({
  components: {
   Layfooter
  },
})
export default class HomeView extends Vue {}
</script>
  <!-- <style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>

<style lang="scss" scoped>
.el-header {
  background-color: rgb(54, 57, 59);
  color: white;
  text-align: left;
  font-size: 20px;
  line-height: 60px;
}

.el-aside {
  background-color: #36393B;
  color: white;
  .el-menu{
    .el-menu-item{
      background-color: #36393b!important;
    }
  }
}
</style> -->